// import 'swiper/swiper.scss';

import modal from './modal';

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';


const swiperEasy = new Swiper('.swiper.easy', {

  slidesPerView: 1, // Mostrar solo un slide por vista
  centeredSlides: true, // Centrar los slides
  loop: true,
  rewind:true,
  direction: 'horizontal',

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',

  },
  modules: [Navigation, Pagination],
})


const swiper = new Swiper(".swiper-products", {
  cssMode: true,
  speed: 500,

  // direction: 'vertical',
  // loop: true,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  mousewheel: true,
  // keyboard: true,
});


if (typeof Swiper !== 'undefined') {
  const advantages = new Swiper(".advantages-slider", {
    speed: 500,
    effect: 'fade',
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    mousewheel: true,
  });
}




(() => {
  const openFeatureList = document.getElementById('action-open-feature-list');

  if (openFeatureList != undefined) {
    let featureList = document.getElementById('feature-list');

    openFeatureList.addEventListener('click', () => {
      if (featureList == undefined) return;

      featureList.classList.toggle('open');
    });
  }
})();
